import * as React from "react";
import {AccountPageWrapper} from "components/account/widgets/AccountPageWrapper";
import {UIState} from "data/UIState";
import {AccountContentContainer} from "components/account/widgets/AccountContentContainer";
import {Transport} from "data/transport";
import {IAccountPage, AccountPages} from "components/account/Account";

interface Props {
  onChangeAccountPage:(page:IAccountPage) => void;
}

export function AccountDataPrivacy(props: Props): JSX.Element {

    const dataExportUrl = Transport.URL('/exportAccount', true);

    return (
      <AccountPageWrapper
        title={"Data & Privacy"}
        subTitle={""}
        backOrCloseAction={() => {
          props.onChangeAccountPage(AccountPages.Overview);
        }}
        backOrCloseLabel={"Back to Account Overview"}
      >
        <AccountContentContainer>
          <div>
            <h2 className={'level2'}>Your Data</h2>
            <p>Export a copy of all data stored in The Wellness Concepts Engage Platform related to you. This export
              will be in
              JSON format. JSON viewers are available readily on the Internet. Simply copy and paste the result of this
              export into the
              viewer of your choice.
            </p>

          </div>
          <div className="action-buttons">
            <div className={"spacer"}></div>
            <a className="primary"  target="_blank" href={dataExportUrl} aria-label={`Export, opens new tab`} >Export</a>
          </div>


            <div>
            <h2 className={'level2'}>Privacy &amp; Consent</h2>
            <p>During signup you reviewed and accepted our <a href={UIState.settings.TOS_DOC}
                                                                                   target="_blank" aria-label={`Terms of Service and Privacy Policy, opens new tab`}>terms of
              service &amp; privacy policy</a>.

              {UIState.settings.ENABLE_GDPR && UIState.settings.GDPR_ITEMS.length > 0 ?
                <>
                  &nbsp;You also gave consent for the following items:
                  <ul>
                    {UIState.settings.GDPR_ITEMS.map(item => <li key={item.id}>{item.profileDescription}</li>)}
                  </ul>
                  You may delete your account at any time to revoke this consent
                  {UIState.settings.ENABLE_SAML_SSO && <>&nbsp;by sending an email to <a
                    href="mailto:strive@well-concepts.com">strive@well-concepts.com</a>. Include your contact
                    information and company with your request</>}
                  .
                </>
                :
                <>
                  &nbsp;You may delete your account at any time
                  {UIState.settings.ENABLE_SAML_SSO && <>&nbsp;by sending an email to <a
                    href="mailto:strive@well-concepts.com">strive@well-concepts.com</a>. Include your contact
                    information and company with your request</>}
                  .
                </>
              }
              &nbsp;Please note, account deletion is a permanent.
            </p>
            </div>

          {!UIState.settings.ENABLE_SAML_SSO &&
              <div className="action-buttons">
                <div className={"spacer"}></div>
                <button className="primary" onClick={()=>{ props.onChangeAccountPage(AccountPages.AccountDeleteConfirmation);  }}>Delete Account</button>
              </div>
            }


        </AccountContentContainer>
      </AccountPageWrapper>
    );
}